import ArticlesTable from "@components/ArticlesTable";
import ExpertJourneyTablesPage from "@components/pageTypes/ExpertJourneyTablesPage";
import { ArticleContentTypeEnum } from "@typing/Generated";

type Props = {
  journeyId: string;
};

const ExpertJourneyArticlesPage = ({ journeyId }: Props) => (
  <ExpertJourneyTablesPage
    helmetKey="pageTitles.expertJourney.article.list"
    imageName="manReadingRadio"
    journeyId={journeyId}
    titleKey="pages.learn.learn"
  >
    <ArticlesTable
      contentTypes={[ArticleContentTypeEnum.text, ArticleContentTypeEnum.video]}
      includeHidden={false}
      journeyId={journeyId}
    />
  </ExpertJourneyTablesPage>
);

export default ExpertJourneyArticlesPage;
